import React, { useEffect, useState, useContext } from "react";
// import TheContext from "./TheContext";
// import axios from "axios";
// import actions from "./api";
// import Auth from "./Auth";
import HeroSection from './Components/HeroSection'
import Cards from './Components/Cards';
import PopUp from './Components/popUp';


function Home(props) {

  return (
    <>
      <HeroSection />
      <Cards />
      <PopUp />
      {/* <div className="alert">
      <h2>Welcome</h2>
<script>
function myFunction() {
  alert("You should be over 21 years old in order to continue shopping to our store")
}

</script>
    <PopUp/>

</div> */}
      {/* <Footer /> */}


    </>
  );


}

export default Home;
